import { createSlice } from "@reduxjs/toolkit";
import { deleteCaseCredit } from "@custom/rtk-apis/Setting/creditForCaseToCase/deleteCaseCredit";

interface deleteCaseCreditState {
  status: string;
  result: {};
  msg: string;
  loading: boolean;
  error: string;
}

const initialState: deleteCaseCreditState = {
  status: "",
  result: {},
  msg: "",
  loading: false,
  error: ""
};

const deleteCaseCreditSlice = createSlice({
  name: "deleteCaseCreditSlice",
  initialState,
  reducers: {
    clearDeleteCaseCreditState: (state) => {
      state.status = '';
      state.result = {};
      state.msg = '';
      state.loading = false;
      state.error = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteCaseCredit.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCaseCredit.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(deleteCaseCredit.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload as string;
        state.status = "FAILED";
      });
  }
});

export default deleteCaseCreditSlice.reducer;
export const { clearDeleteCaseCreditState } = deleteCaseCreditSlice.actions;
